import { Link } from 'react-scroll';
import { FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import {
  header,
  headerScrolled,
  headerNotScrolled,
  container,
  logo,
  logoImage,
  nav,
  navLink,
  buttonsContainer,
  whatsappButton,
  instagramButton,
  instagramButtonScrolled,
  instagramButtonNotScrolled,
} from './Header.styles';

import LogoWhiteHorizontal from '../../assets/logowhitehorizontal1.png';
import LogoBlackHorizontal from '../../assets/logoblackhorizontal1.png';
import { handleOpenLink } from '../../utils/common';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`${header} ${scrolled ? headerScrolled : headerNotScrolled}`}
    >
      <div className={container}>
        <a href='#inicio' className={logo(scrolled)}>
          <img
            src={!scrolled ? LogoBlackHorizontal : LogoWhiteHorizontal}
            alt='Logo clínica'
            className={logoImage}
          />
        </a>

        {!isMobile && (
          <nav className={nav(scrolled)}>
            <Link
              to='inicio'
              smooth={true}
              duration={600}
              offset={-84}
              className={navLink}
            >
              Início
            </Link>
            <Link
              to='procedimento'
              smooth={true}
              duration={600}
              offset={-84}
              className={navLink}
            >
              Procedimento
            </Link>
            <Link
              to='resultados'
              smooth={true}
              duration={600}
              offset={-84}
              className={navLink}
            >
              Resultados
            </Link>
            <Link
              to='clinica'
              smooth={true}
              duration={600}
              offset={-84}
              className={navLink}
            >
              Clínica
            </Link>
            <Link
              to='avaliacoes'
              smooth={true}
              duration={600}
              offset={-84}
              className={navLink}
            >
              Avaliações
            </Link>
            <Link
              to='sobre'
              smooth={true}
              duration={600}
              offset={-80}
              className={navLink}
            >
              Sobre
            </Link>
          </nav>
        )}

        <div className={buttonsContainer}>
          <button
            onClick={() =>
              handleOpenLink(
                'https://wa.me/+5519996268961?text=Ol%C3%A1,%20venho%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20agendar%20uma%20Avalia%C3%A7%C3%A3o%20em%20Harmoniza%C3%A7%C3%A3o%20Orofacial%20com%20a%C2%A0Dra%C2%A0Bruna%C2%A0Fais.',
                'agendar_consulta_click',
                'Agendar consulta',
                window.location.pathname
              )
            }
            className={whatsappButton}
          >
            <FaWhatsapp /> Whatsapp
          </button>
          <button
            onClick={() =>
              handleOpenLink(
                'https://www.instagram.com/drabfclinic/',
                'instagram_click',
                'Acessar Instagram',
                window.location.pathname
              )
            }
            className={`${instagramButton} ${
              scrolled ? instagramButtonScrolled : instagramButtonNotScrolled
            }`}
          >
            <FaInstagram /> Instagram
          </button>
        </div>
      </div>
    </header>
  );
}
